// componente para olvide mi contraseña

import { useState, useContext } from "react";

// react translation
import { useTranslation } from "react-i18next";

// url cliente
import { UrlClient } from "../constants/constants.js";


// components importation
import { Close, EmailCheck } from "../icons/AppIcons.jsx";


// url imports
import { urls } from "../../api-urls/api-urls.js";



// lang context importation
import { LangContext } from "../../context/LangContext.jsx";






export const ForgotPassW = ({ onClose }) => {

  // GET the lang context
  const { lang } = useContext(LangContext);


  // GET the react translation
  const [t] = useTranslation("global");

  const [email, setEmail] = useState("");
  const [emailVal, setEmailVal] = useState(true);
  const [emailSend, setEmailSend] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);


  // funcion para validar el email
  const onHandleValEmail = (newVal = "") => {
    const patron = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (patron.test(newVal)) {
      setEmailVal(false);
    } else {
      setEmailVal(true);
    }

    setEmail(newVal);
  };


  // funcion para enviar la inform al serv
  const onHandleSubmit = async (event) => {
    event.preventDefault();

    const END_POINT = `${urls.authRoute}/recover-passwd-ext-user?language=${lang}&urlC=${UrlClient}`;

    try {
      setLoading(true);
      setEmailVal(true);
      const response = await fetch(END_POINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (response.status === 200) {
        setEmailSend(true);
        setEmailVal(true);
      } else if (response.status === 404) {
        setError(data?.msg);
      } else if (response.status === 500) {
        setError(data?.msg);
        setEmailVal(true);
      }

      setEmailVal(false);
      setLoading(false);

    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="background-modal">
      <div className="container-modal-forg-passw">
        <div style={{ marginTop: "10px" }} className="row-flex j-content-s-b">
          <h4>{!emailSend ? t("HomeViewComp.olvidaste_pwd") : t("HomeViewComp.recibiste")}</h4>
          <button type="reset" className="btn-close" style={{ fontWeight: "bold" }} onClick={onClose}>
            <Close />
          </button>
        </div>
        {
          !emailSend && (
            <p className="txt-muted">
              {t("HomeViewComp.txt_olvidaste_pwd")}
            </p>
          )
        }

        {
          emailSend && (
            <>
              <p style={{ textAlign: "center" }}>
                <EmailCheck />
              </p>
              <p>
                <span className="txt-muted">{t("HomeViewComp.instr_enviad")}<strong>{email}</strong></span>
                <br />
                <small style={{ color: "#cf2424", fontSize: "15px" }}>{t("HomeViewComp.sino_encuent")}</small>
              </p>
            </>
          )
        }

        {
          error && (
            <p style={{ color: "var(--danger-color)" }}>{error}</p>
          )
        }

        <form onSubmit={onHandleSubmit}>
          <label style={{ cursor: "auto", fontWeight: "bold", fontSize: "16px" }} className="label-pwd" htmlFor="email">{t("HomeViewComp.ingr_correo")}</label>
          <input
            style={{ marginTop: "3px" }}
            className="input-control-text"
            type="text"
            name="email-ad"
            id="email"
            value={email}
            disabled={emailSend}
            onChange={({ target }) => onHandleValEmail(target.value)}
            placeholder={t("HomeViewComp.ingr_correo")} />

          <div style={{ textAlign: "center" }}>
            {
              loading ? (
                <div className="spinner-hed" style={{marginTop: "0.5rem"}}></div>
              )
                :
                (
                  <button
                    type={emailVal ? "button" : "submit"}
                    disabled={emailVal}
                    className={`btn-send-inst ${emailVal && "disabled-class"}`}>{t("HomeViewComp.enviar_instruc")}</button>
                )
            }
          </div>
        </form>
      </div >
    </div >
  );
};